import { ReactComponent as IconEye } from "@/assets/svgs/Union-eye.svg";
import { ReactComponent as DocumentIssue } from "@/assets/svgs/document-issue.svg";
import Button from "@/components/Button";
import PropTypes from "prop-types";
import { useMemo } from "react";

export const ConfigureIssuanceCard = ({ etrIssuanceEnabled, handleEdit, noEtrPersonaSelected, blockchainNetworks }) => {
	// Filter out the networks that are not enabled
	const enabledNetworks = useMemo(
		() => blockchainNetworks?.filter((network) => network.$selected),
		[blockchainNetworks]
	);

	return (
		<div className="request-enrolment-admin__confirmation-tile request-enrolment-admin__confirmation-tile__right">
			<div className="layout-request__tile__content">
				<div className="request-enrolment-confirmation-header request-enrolment-admin__confirmation-tile__right__header etr-issuance__border-none">
					<div>
						<div className="layout-request__title__content__header__left">
							<div className="request-title request-enrolment-confirmation-header-title">
								Issuance Configuration
							</div>
						</div>
					</div>
					{!noEtrPersonaSelected && (
						<div className="layout-request__title__content__header__right">
							<Button text="Edit" ghost submit={handleEdit}></Button>
						</div>
					)}
				</div>
				<div
					className={
						"etr-issuance__warning-container " +
						(etrIssuanceEnabled && !noEtrPersonaSelected
							? `etr-issuance__warning-container--enabled`
							: `etr-issuance__warning-container--disabled`)
					}
				>
					<IconEye className="etr-issuance__icon-default" />
					<p className="etr-issuance__text-subtitle">
						{noEtrPersonaSelected
							? "Issuance unavailable for the selected persona."
							: etrIssuanceEnabled
								? "ETR Issuance enabled"
								: "ETR Issuance disabled"}
					</p>
				</div>
				{etrIssuanceEnabled && (
					<div className="enrolment-request__tile__content">
						{enabledNetworks?.map((network, index) => (
							<div
								className="layout-request__tile__content__sub__header request-enrolment-admin__confirmation-tile__right__sub-header"
								key={index}
							>
								<div className="request-enrolment-admin__confirmation-tile__sub-header__icon confirmation-tile__persona-icon">
									<DocumentIssue />
								</div>
								<div className="request-enrolment-admin__confirmation-tile__sub-header__content">
									<div className="etr-issuance__flex-column">
										{network.label}
										<p className="etr-issuance__text-subtitle">
											Included
										</p>
									</div>
								</div>
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

ConfigureIssuanceCard.propTypes = {
	etrIssuanceEnabled: PropTypes.bool,
	handleEdit: PropTypes.func,
	noEtrPersonaSelected: PropTypes.bool,
	blockchainNetworks: PropTypes.array,
};
